export default "__VITE_ASSET__CAaZjAnX__"